var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMitsubishi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 430,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E60012",
    d: "M248 6l82 139-82 139-82-138L248 6zm0 278h160l80 136H328l-80-136zm0 0H88L8 420h160l80-136z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitsubishi);
export default __webpack_public_path__ + "static/media/mitsubishi.7fe1a119d388b666277a0ff4956c6aaa.svg";
export { ForwardRef as ReactComponent };